/**
 * Check if argument is an instance of Array.
 *
 * @param arg {*}.
 * @returns {boolean}
 */
export default function isArray(arg) {
  return Object.prototype.toString.call(arg) === '[object Array]';
}
